import React, { useState } from 'react';
import { Tooltip, useTheme } from '@mui/material';
import TaskPreview from './TaskPreview';
import GhostTaskTooltip from './GhostTaskTooltip';

const TaskBarTooltip = ({ task, isGhost, isEditMode, children }) => {
  const theme = useTheme();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const originalTask = task.originalTask || task;

  // Lazy-loaded tooltip content - only renders when tooltip is open
  const getTooltipContent = () => {
    if (!tooltipOpen) return null;

    if (isGhost) {
      return <GhostTaskTooltip task={task} originalTask={originalTask} />;
    }

    // Use lightweight TaskPreview instead of heavy TaskCard
    return <TaskPreview task={originalTask} />;
  };

  // Disable tooltip in edit mode
  if (isEditMode) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      title={getTooltipContent()}
      placement="bottom-start"
      arrow
      onOpen={() => setTooltipOpen(true)}
      onClose={() => setTooltipOpen(false)}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper',
            color: 'text.primary',
            boxShadow: theme.shadows[4],
            border: isGhost ? `2px dashed ${theme.palette.grey[400]}` : `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            maxWidth: 500,
            p: 0,
          }
        },
        arrow: {
          sx: {
            color: 'background.paper',
            '&::before': {
              border: isGhost ? `1px dashed ${theme.palette.grey[400]}` : `1px solid ${theme.palette.divider}`,
            }
          }
        }
      }}
    >
      {children}
    </Tooltip>
  );
};

export default TaskBarTooltip;
